module.exports = __webpack_public_path__ + "img/03焦点.4b5eb5d6.png";